/**
 * API 基礎 URL 配置
 * 測試區與正式區分開管理，方便逐步替換寫死的 URL
 */

// API 基礎路徑
export const API_BASE_URL = 'https://www.autoturn.net/api';

// 網站基礎路徑（用於 logout 等頁面跳轉）
export const SITE_BASE_URL = 'https://www.autoturn.net';
